import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Toastify from '../../utils/tostfy';
import { handleApiCall } from '../../apis';
import { endpoint } from '../../utils/endpoints';
import Loader from '../../Components/Loader/Loader';

function AddTeacher() {
    const location = useLocation()
    const [regionList, setRegionList] = useState([]);
    const [regionId, setRegionId] = useState("");
    const [countryList, setCountryList] = useState([]);
    const [countryId, setCountryId] = useState("");
    const [stateList, setStateList] = useState([]);
    const [stateId, setStateId] = useState("");
    const [districtList, setDistrictList] = useState([]);
    const [districtId, setDistrictId] = useState("");
    const [blockList, setBlockList] = useState([]);
    const [blockId, setBlockId] = useState("");
    const [schoolname, setSchoolname] = useState("")
    const [schoolid, setSchoolid] = useState("")
    const [schooladdress, setSchooladdress] = useState("")
    const [updateSchool, setUpdateSchool] = useState(false)

    const navigate = useNavigate();


    useEffect(() => { getRegionList(); }, []);
    useEffect(() => { getCountryList(); }, [regionId]);
    useEffect(() => { getStateList(); }, [countryId]);
    useEffect(() => { getDistrictList(); }, [stateId]);
    useEffect(() => { getBlockList(); }, [districtId]);

    const editData = () => {
        if (location?.state) {
            console.log(location.state, "Dataa==>>")
            setUpdateSchool(true)
            setSchoolname(location?.state?.name)
            setSchoolid(location?.state?.school_unique_id)
            setSchooladdress(location.state.school_address)
            setRegionId(location?.state?.region_id)
            setCountryId(location?.state?.country_id)
            setDistrictId(location.state.district_id)
            setBlockId(location?.state?.block_id)
            setStateId(location?.state?.state_id)
        }
    }

    useEffect(() => {
        editData()
    }, [])



    const getRegionList = async () => {
        try {
            const response = await handleApiCall("get", `${endpoint.regionList}`, {});
            if (response?.data?.code === 200) setRegionList(response.data.data);
            else toast.error(response?.response?.data?.message);
        } catch (e) { console.log("Error fetching region list:", e); }
    };

    const getCountryList = async () => {
        if (!regionId) return;
        try {
            const response = await handleApiCall("get", `${endpoint.countryList}?region_id=${regionId}`, {});
            if (response?.data?.code === 200) setCountryList(response.data.data);
        } catch (e) { console.log("Error fetching country list:", e); }
    };

    const getStateList = async () => {
        if (!countryId) return;
        try {
            const response = await handleApiCall("get", `${endpoint.stateList}?country_id=${countryId}`, {});
            if (response?.data?.code === 200) setStateList(response.data.data);
        } catch (e) { console.log("Error fetching state list:", e); }
    };

    const getDistrictList = async () => {
        if (!stateId) return;
        try {
            const response = await handleApiCall("get", `${endpoint.district}?state_id=${stateId}`, {});
            if (response?.data?.code === 200) setDistrictList(response.data.data);
        } catch (e) { console.log("Error fetching district list:", e); }
    };

    const getBlockList = async () => {
        if (!districtId) return;
        try {
            const response = await handleApiCall("get", `${endpoint.blocklist}?district_id=${districtId}`, {});
            if (response?.data?.code === 200) setBlockList(response.data.data);
        } catch (e) { console.log("Error fetching block list:", e); }
    };

    // Reset dependent fields when parent field changes
    const handleRegionChange = (value) => {
        setRegionId(value);
        setCountryId("");
        setStateId("");
        setDistrictId("");
        setBlockId("");
        setCountryList([])
        setStateList([])
        setDistrictList([])
        setBlockList([])
    };

    const handleCountryChange = (value) => {
        setCountryId(value);
        setStateId("");
        setDistrictId("");
        setBlockId("");
        setStateList([])
        setDistrictList([])
        setBlockList([])
    };

    const handleStateChange = (value) => {
        setStateId(value);
        setDistrictId("");
        setBlockId("");
        setDistrictList([])
        setBlockList([])
    };

    const handleDistrictChange = (value) => {
        setDistrictId(value);
        setBlockId("");

        setBlockList([])
    };
    const addSchool = async (e) => {
        e.preventDefault();
        // Validate required fields
        if (!schoolname?.trim()) return toast.error("School Name is required");
        if (!schoolid?.trim()) return toast.error("School ID is required");
        if (!schooladdress?.trim()) return toast.error("School Address is required");
        if (!regionId) return toast.error("Region is required");
        if (!countryId) return toast.error("Country is required");
        if (!stateId) return toast.error("State is required");
        if (!districtId) return toast.error("District is required");
        setLoading(true)
        try {
            const response = await handleApiCall(location?.state?.screen == 'edit' ? "put" : "post", location?.state?.screen == 'edit' ? endpoint.editSchool : endpoint.addSchool, location?.state?.screen == 'edit' ? {
                id: location.state._id,
                name: schoolname?.trim(),
                school_unique_id: schoolid,
                school_address: schooladdress,
                region_id: regionId,
                country_id: countryId,
                state_id: stateId,
                district_id: districtId,
                block_id: blockId
            } :
                {
                    name: schoolname,
                    school_unique_id: schoolid,
                    school_address: schooladdress,
                    region_id: regionId,
                    country_id: countryId,
                    state_id: stateId,
                    district_id: districtId,
                    block_id: blockId
                });
            console.log(response, "Add School")
            if (response?.data?.code === 200) {
                toast.success(response?.data?.message);
                setTimeout(() => {
                    navigate(-1);
                }, 1000);
            } else {
                toast.error(response?.response?.data?.errorMessage || "Failed to add school");
                setLoading(false)
            }
        } catch (error) {
            console.error("Error adding school:", error);
            toast.error("Something went wrong!");
            setLoading(false)
        }
    };

    const handleCancel = () => {
        if (location?.state) {
            editData(); // Call editData if location.state exists
            setLoading(false)
        } else {
            // Reset state values to empty strings if there's no location.state
            setSchoolname("");
            setSchoolid("");
            setSchooladdress("");
            setRegionId("");
            setCountryId("");
            setStateId("");
            setDistrictId("");
            setBlockId("");
        }
        navigate("/school-management");
    };
    const [loading, setLoading] = useState(false)



    return (
        <>
            <Toastify />
            <Loader isLoading={loading} /> {/* Call Loader */}
            <form action='#' method='post' className="common-table-wrapper m-0" onSubmit={addSchool}>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 px-4 py-1">
                    <input
                        type="text"
                        required
                        maxLength={150}
                        value={schoolname}
                        onChange={(e) => {
                            let value = e.target.value;

                            // Remove leading non-alphanumeric characters (including spaces and special characters)
                            value = value.replace(/^[^a-zA-Z0-9]+/, "");

                            setSchoolname(value);
                        }}
                        placeholder="School Name"
                        className="p-2 bg-[#F6F6F6] border-[1px] font-bold border-black rounded-md focus:outline-none w-full h-full"
                    />
                    <input
                        required
                        value={schoolid}
                        onChange={(e) => {
                            let value = e.target.value;

                            // Remove all leading spaces or special characters
                            value = value.replace(/^[\s\W_]+/, "");

                            setSchoolid(value);
                        }}
                        type="text"
                        placeholder="School Id"
                        className="p-2 bg-[#F6F6F6] font-bold text-black border-[1px] border-black rounded-md focus:outline-none w-full h-full"
                    />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 p-4">
                    <select
                        required
                        value={regionId}
                        onChange={(e) => handleRegionChange(e.target.value)}
                        className="p-2 bg-[#F6F6F6] font-bold border-[1px] border-black rounded-md focus:outline-none w-full h-full"
                    >
                        <option value="" disabled selected>
                            Choose Region
                        </option>
                        {regionList.length > 0 ? (
                            regionList.map(item => (
                                <option key={item._id} value={item._id}>{item.name}</option>
                            ))
                        ) : (
                            <option value="" disabled>
                                No Region Available
                            </option>
                        )}
                    </select>

                    <select
                        required
                        value={countryId}
                        onChange={(e) => handleCountryChange(e.target.value)}
                        className="p-2 bg-[#F6F6F6] font-bold border-[1px] border-black rounded-md focus:outline-none w-full h-full"
                    >
                        <option value="" disabled selected>
                            Choose Country
                        </option>
                        {countryList.length > 0 ? (
                            countryList.map(item => (
                                <option key={item._id} value={item._id}>{item.name}</option>
                            ))
                        ) : (
                            <option value="" disabled>
                                No Country Available
                            </option>
                        )}
                    </select>

                    <select
                        required
                        value={stateId}
                        onChange={(e) => handleStateChange(e.target.value)}
                        className="p-2 bg-[#F6F6F6] font-bold border-[1px] border-black rounded-md focus:outline-none w-full h-full"
                    >
                        <option value="" disabled selected>
                            Choose State
                        </option>
                        {stateList.length > 0 ? (
                            stateList?.map(item => (
                                <option key={item._id} value={item._id}>{item.name}</option>
                            ))
                        ) : (
                            <option value="" disabled>
                                No State Available
                            </option>
                        )}
                    </select>

                    <select
                        required
                        value={districtId}
                        onChange={(e) => handleDistrictChange(e.target.value)}
                        className="p-2 bg-[#F6F6F6] font-bold border-[1px] border-black rounded-md focus:outline-none w-full h-full"
                    >
                        <option value="" disabled selected>
                            Choose District
                        </option>
                        {districtList.length > 0 ? (
                            districtList.map(item => (
                                <option key={item._id} value={item._id}>{item.name}</option>
                            ))
                        ) : (
                            <option value="" disabled>
                                No District Available
                            </option>
                        )}
                    </select>
                    <select
                        required
                        value={blockId}
                        onChange={(e) => {
                            setBlockId(e.target.value);

                        }}
                        className="p-2 bg-[#F6F6F6] font-bold border-[1px] border-black rounded-md focus:outline-none w-full h-full"
                    >
                        <option value="" disabled selected>
                            Choose Block
                        </option>
                        {blockList.length > 0 ? (
                            blockList.map(item => (
                                <option key={item._id} value={item._id}>{item.name}</option>
                            ))
                        ) : (
                            <option value="" disabled>
                                No Block Available
                            </option>
                        )}
                    </select>

                    <input
                        required
                        value={schooladdress}
                        max={150}
                        onChange={(e) => {
                            let value = e.target.value;

                            // Prevent leading spaces but allow spaces elsewhere
                            value = value.replace(/^[^a-zA-Z0-9]+/, "");

                            setSchooladdress(value);
                        }}
                        type="text"
                        placeholder="School Address"
                        className="p-2 bg-[#F6F6F6] border-[1px] font-bold text-black border-black rounded-md focus:outline-none w-full h-full"
                    />
                </div>

                <div className='flex gap-3 mx-2 mt-3 px-3'>
                    <button
                        type="button"  // Prevents form submission
                        onClick={handleCancel}
                        className="text-black bg-[#E5DED4]  bg-opacity-25 font-bold px-4 py-2 rounded-md border-[2px]">
                        Cancel
                    </button>

                    <button
                        type="submit"
                        className="text-white bg-[#994263] px-5 font-bold py-2 rounded-md border-[2px]">
                        {updateSchool ? "Update" : "Add"}
                    </button>
                </div>
            </form>
        </>
    );
}

export default AddTeacher;
